export const STRIPE_PAYMENT_SOURCES_PAGE_SIZE = 5;
